export default {
  mounted() {
    this.$root.$on('page.refresh', this.refresh);
  },
  destroyed() {
    this.$root.$off('page.refresh', this.refresh);
  },
};
